import React from "react";
import Container from "./styled";
import { IoClose } from "react-icons/io5";
import ChangeTextTabs from "./changeTextTabs";
import { BsCheckLg, BsLifePreserver } from "react-icons/bs";
import { FiAlertCircle } from "react-icons/fi";
import { MdOutlineLocalOffer } from "react-icons/md";

export default class IkeModalStepTwo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentMode: "cobertura",
    };
  }

  getTexts(currentMode) {
    const texts = {
      cobertura: (
        <div className="coberturaContainer opacidad04">
          <h4>
            <span>
              <BsLifePreserver />
            </span>
            Detalles de cobertura
          </h4>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Traslado de bicicleta (50km lineales y 2 eventos anuales)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Gastos médicos por accidente, robo o su intento ($3.000 y 1 evento
            anual)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Retorno a domicilio ($1.500 y 1 evento anual)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Reembolso de gastos de documentos ($1.500 y 1 evento anual)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Cambio de cerradura de domicilio ($3.000 y 1 evento anual)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Referencia de bicicleterias (Sin límite)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Consultoria legal telefónica (Sin límite)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Descuento 40% compra de artículos bicicletas* ($2.000 y 2 eventos
            semestrales)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Médico virtual (Sin límite)
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            IKE+ - www.ikemas.com.ar (Sin límite)
          </p>
          <p id="carencia">* Carencia de 60 días</p>
        </div>
      ),
      descuentos: (
        <div className="descuentosContainer opacidad04">
          <h4>
            <span>
              <MdOutlineLocalOffer />
            </span>
            50% de descuento en los siguientes servicios
          </h4>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Engrase de transmisión
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Revisión ajuste de cambios
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Revisión ajuste de frenos
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Revisión de tornería y cierre de ruedas
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Ajuste y alineación de ruedas
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Revisión de presión de neumáticos
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Arreglo de pinchadura
          </p>
          <p>
            <span>
              <BsCheckLg />
            </span>
            Centrado de las ruedas
          </p>
          <p id="hastaEventos">
            <span>
              <FiAlertCircle />
            </span>
            Hasta $1.000 por evento
          </p>
          <p id="eventosAnuales">
            <span>
              <FiAlertCircle />
            </span>
            Total 5 eventos anuales
          </p>
        </div>
      ),
    };
    return texts[currentMode];
  }

  toggleTexts = (currentMode) => {
    this.setState({ currentMode });
  };

  render() {
    return (
      <Container>
        {/* Modal Box */}
        <div className="box topInOpacity5">
          <div className="closeButtonContainer">
            <a onClick={this.props.handleClose}>
              <IoClose />
            </a>
          </div>
          <div className="imageTitleButtonsContainer">
            <div className="imageTitleContainer">
              <div className="imageContainer">
                <img alt="Iké Logo" src="images/logos/ike.svg"></img>
              </div>
              <h4>Plan Asistencia Full Bici</h4>
            </div>
            <ChangeTextTabs toggleTexts={this.toggleTexts}></ChangeTextTabs>
          </div>
          {this.getTexts(this.state.currentMode)}
          <div id="proximoPaso">
            <p>Vigencia Anual - 12 cuotas mensuales de $400 c/u.</p>
          </div>
        </div>
      </Container>
    );
  }
}
